import { useRef } from "react";
import useTranslations from "../../../core/i18n/useTranslations";
import Icon from "../Icon";
import { PopupContextMenuLinkButton } from "../Menus/PopupContextMenu/PopupContextMenuLinkButton";

import styles from "./PhotoWrapperWithUpload.module.css";

export const UpdateDeletePhoto = ({
  photoURL,
  photoData,
  alternativeString,
  removeImg,
  handleUpload,
}: {
  photoURL: string;
  photoData: {
    preview: string;
    raw: string;
  };
  alternativeString?: string;
  removeImg: () => Promise<void>;
  handleUpload: (e: any) => Promise<void>;
}) => {
  const t = useTranslations();
  const labelRef = useRef<HTMLLabelElement>(null);

  return (
    <div
      tabIndex={0}
      aria-label="Object photo manage"
      className={styles.imgContainer}
    >
      <div className={styles.hoverContent}>
        <Icon name="photograph" color="Primary-700" />
      </div>
      <img
        className={styles.buttonContent}
        src={photoData.preview || photoURL}
        alt={alternativeString ?? "image"}
      />
      <div className={styles.imgPopup}>
        <label
          ref={labelRef}
          className={styles.updateLabel}
          htmlFor="updatePhoto"
        >
          {t("Objects:update_photo")}
          <input
            type="file"
            id="updatePhoto"
            onChange={handleUpload}
            accept="image/jpeg"
          />
        </label>
        <PopupContextMenuLinkButton
          icon="camera"
          text={t("Objects:update_photo")}
          onClick={() => labelRef.current?.click()}
        />
        <PopupContextMenuLinkButton
          icon="trash"
          text={t("Objects:remove_photo")}
          onClick={removeImg}
        />
      </div>
    </div>
  );
};
